/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from "prop-types";

import MenuLink from "modules/common/components/MenuLink";

const SubmenuContent = ({ submenu, ...props }) =>
  submenu.map((item) => <MenuLink menuItem={item} key={item.label} mb={4} display="block" {...props} />);

export default SubmenuContent;

SubmenuContent.propTypes = {
  submenu: PropTypes.arrayOf(
    PropTypes.shape({
      page: PropTypes.string,
      label: PropTypes.string,
    })
  ),
};
